// Status badge for an event card/row, shared by the events list
// (src/Events/list) and the /hosts drill-down. This used to exist as two
// copies that drifted: the /hosts copy lost the cancelled branch, so cancelled
// events rendered there as Ongoing/Upcoming. Cancellation must win over
// everything else — a cancelled event is never live, whatever its date says.
export const getEventStatus = (event) => {
  const now = new Date();
  const eventDate = event.date.toDate();
  const eventEndTime = new Date(eventDate.getTime() + (event.duration || 3) * 60 * 60 * 1000); // Default 3 hours

  if (event.status === 'cancelled') return { status: 'cancelled', color: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300', label: 'Cancelled' };
  if (event.isCompleted) return { status: 'completed', color: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300', label: 'Completed' };
  if (now >= eventDate && now <= eventEndTime) return { status: 'ongoing', color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300', label: 'Ongoing' };
  if (now < eventDate) return { status: 'upcoming', color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200', label: 'Upcoming' };
  return { status: 'past', color: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200', label: 'Past' };
};
